import { isSameId } from "../../helpers";
export default function (store, { id, userId }) {
    const users = store.getState().usersMap;
    if (!users[userId?.toString()])
        return;
    const task = store.getTask(id);
    if (!task?.assigned?.some(i => isSameId(i, userId))) {
        store.in.exec("update-task", {
            id,
            task: {
                ...task,
                assigned: task?.assigned?.length
                    ? [...task.assigned, userId]
                    : [userId],
            },
        });
    }
}
//# sourceMappingURL=assign.js.map